module.exports = __webpack_public_path__ + "static/web-dev-mobile-a4b06956da2d00d52e82400853837aef.jpg";